import { combineReducers } from '@reduxjs/toolkit';

import isLoading from './isLoading';

/**
 * @typedef {{
 *  isLoading: import('./isLoading').IsLoadingState,
 * }} SendState
 */

export default combineReducers({
  isLoading,
});
